export const BREAKPOINTS = {
  EXTRA_SMALL: 320,
  SMALL: 502,
  MEDIUM: 682,
  LARGE: 1042,
  EXTRA_LARGE: 1280,
  XXL: 1920,
}
